const getters = {
	token: state => state.user.token,
	roles: state => state.user.roles,
	shopList: state => state.user.shopList,
	shopInfo: state => state.user.shopInfo,
	sellerInfo: state => state.user.sellerInfo,
	permissionRouters: state => state.permission.routers,
	addRouters: state => state.permission.addRouters,
    workground: state => state.permission.workground,
    proWorkground: state => state.permission.proWorkground
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js